const content = `
<p>
  <strong>
    <u>
      重要须知：
    </u>
  </strong>
  图灵鉴定App/微信小程序/图灵鉴定H5⼀贯重视用户的个人信息及个人隐私的保护，在您使用图灵鉴定App/微信小程序/图灵鉴定H5的服务和/或在图灵鉴定App/微信小程序/图灵鉴定H5购物的时候，平台有可能会收集和使用您的个人信息及隐私。
  <strong>
    <u>
      为此，图灵鉴定App/微信小程序/图灵鉴定H5通过本《隐私权政策》向您说明您在使用图灵鉴定App/微信小程序/图灵鉴定H5的服务和/或在图灵鉴定App/微信小程序/图灵鉴定H5购物时，平台是如何收集、保存、使用和分享这些信息的，以及平台向您提供的访问、更新、控制和保护这些信息的方式。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong>
    <u>
      本《隐私权政策》与您使用平台的服务、在平台购物息息相关，请您务必仔细阅读、充分理解（未成年人应当在其监护⼈的陪同下阅读）。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong>
    <u>
      在使用图灵鉴定App/微信小程序/图灵鉴定H5各项产品或服务前，请您务必仔细阅读本政策，特别是以粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。
    </u>
  </strong>
  如对本政策内容有任何疑问、意见或建议，您可通过平台提供的各种联系方式与我们取得联系。
</p>
<p>
  <br>
</p>
<p>
  <strong>
    本隐私权政策将帮助您了解以下内容：
  </strong>
</p>
<p>
  <strong>
    一.定义、保证及适用范围
  </strong>
</p>
<p>
  <strong>
    二.我们如何收集和使用您的个人信息
  </strong>
</p>
<p>
  <strong>
    三.我们如何使用Cookie和第三方服务
  </strong>
</p>
<p>
  <strong>
    四.我们如何管理及保护您的个人信息
  </strong>
</p>
<p>
  <strong>
    五.您的权利
  </strong>
</p>
<p>
  <strong>
    六.我们如何共享、转让、公开披露您的信息
  </strong>
</p>
<p>
  <strong>
    七.我们如何处理未成年人的信息
  </strong>
</p>
<p>
  <strong>
    八.如何联系我们
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong>
    ⼀、定义、保证及适用范围
  </strong>
</p>
<p>
  <strong>
    （一）定义
  </strong>
</p>
<p>
  1、
  <strong>
    图灵鉴定
  </strong>
  ：指图灵鉴定官网（域名为turingsenseai.com）网站及图灵鉴定APP、小程序。
</p>
<p>
  2、
  <strong>
    图灵鉴定服务的提供者
  </strong>
  ：即图灵鉴定的运营者图灵深视（南京）科技有限公司及其关联公司
</p>
<p>
  3、
  <strong>
    个人信息
  </strong>
  ：是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。包括但不限于您在注册或使用平台时填写或生成的
  <strong>
    <u>
      姓名、住址、联系方式、⽀付信息、交易信息、面部生物识别信息
    </u>
  </strong>
  等单独或与其他信息对照可以识别特定个⼈的信息。
</p>
<p>
  4、
  <strong>
    个人敏感信息：
  </strong>
  指包括
  <strong>
    身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童信息
  </strong>
  等的个人信息（我们将在本政策中对具体个人敏感信息以
  <strong>
    粗体
  </strong>
  进行显著标识）
</p>
<p>
  5、
  <strong>
    儿童：
  </strong>
  指不满十四周岁的未成年人。
</p>
<p>
  6、
  <strong>
    系统权限：
  </strong>
  是指您在使用平台部分功能时授权平台可调用的系统权限，包括但不限于：
  <strong>
    <u>
      系统相册（如照⽚存储在外置存储设备，则会调⽤外置存储设备中的照⽚信息）、摄像头、地理位置、⻨克⻛。
    </u>
  </strong>
  该等系统权限的调用将事先获得您的同意，您也可在“我的-设置-隐私设置-权限管理”去设置您的系统权限，选择打开或关闭。
</p>
<p>
  <strong>
    （二）保证
  </strong>
</p>
<p>
  <strong>
    <u>
      您承诺并保证：您主动填写或者提供给平台的个⼈信息是真实的、准确的、完整的。⽽且，填写或者提供给平台后，如果发⽣了变更的，您会在第⼀时间内，通过原有的渠道或者平台提供的新的渠道进⾏更新，以确保
      平台所获得的您的这些个⼈信息是最新的、真实的、准 确的和完整的；否则，平台⽆须承担由此给您造成的任何损失。
    </u>
  </strong>
</p>
<p>
  <strong>
    （三）适用范围
  </strong>
</p>
<p>
  本政策适用于图灵鉴定服务提供者以图灵鉴定网站、APP、小程序以及随技术发展出现的新形态向您提供的各项产品和服务。我们的关联公司就其向您提供的产品或服务单独设立有隐私政策或个人信息处理规则的，则相应产品或服务适用相应的隐私权政策或个人信息处理规则。
</p>
<p>
  除本政策说明的相关信息收集使用活动外，本政策不适用于本平台上接入其他第三方主体向您提供的其他服务，其他服务适用其向您另行说明的隐私政策等个人信息收集使用规则。
</p>
<p>
  <br>
</p>
<p>
  <strong>
    ⼆、我们如何收集和使⽤您的个⼈信息
  </strong>
</p>
<p>
  在您使用我们的产品/服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：
</p>
<p>
  1、为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务；
</p>
<p>
  2、为实现向您提供我们产品及/或服务的附加功能，您可选择是否授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果。
</p>
<p>
  我们在此特别提醒您：
</p>
<p>
  1、我们致力于打造多样的产品和服务以满足您的需求。
  <strong>
    <u>
      因我们向您提供的产品和服务种类众多，且不同用户选择使用的具体产品/服务范围存在差异，故基本/附加功能及对应收集使用的个人信息类型、范围等会有所区别，请以具体的产品/服务功能为准；
    </u>
  </strong>
</p>
<p>
  2、
  <strong>
    <u>
      为给您带来更好的产品和服务体验，我们持续努力改进我们的产品、服务及技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。如发生上述情形，我们将通过更新政策、弹窗、消息推送、页面红点提示等方式另行向您详细说明，并为您提供自主选择同意的方式，且在征得您明示同意后再开始收集、使用。
    </u>
  </strong>
  在此过程中如果您有任何疑问、意见或建议，您可通过本政策文末联系方式与我们联系，我们会尽快为您作出解答
</p>
<p>
  我们会为您提供的各项具体功能场景包括：
</p>
<p>
  <strong>
    （⼀）注册及使⽤
  </strong>
</p>
<p>
  如您注册图灵鉴定App/微信⼩程序/图灵鉴定H5账户时，我 们将收集您的
  <strong>
    <u>
      ⼿机号码
    </u>
  </strong>
  进⾏实名校验，收集您的
  <strong>
    <u>
      注册昵称及头像
    </u>
  </strong>
  ⽤于公开展示以保证交易辨识度，如您需要上传头像，则上传需要调⽤
  <strong>
    <u>
      相册及/或摄像头
    </u>
  </strong>
  权限。如您使⽤第三⽅应⽤授权登陆，则我们将收集您的
  <strong>
    <u>
      第三⽅账户信息
    </u>
  </strong>
  ，并与您的图灵鉴定App/微信⼩程序/图灵鉴定H5 账户进⾏绑定，使您可通过第三⽅账号直接登录、使⽤我们的产品或服务，我们将在您的授权同意的范围内使⽤您的相关信息。
</p>
<p>
  <strong>
    <u>
      如果您需要注册为个⼈卖家，⾸先您需确保已满18周岁。
    </u>
  </strong>
  在满⾜上述年龄限制的前提下，除了上述收集的信息外，我们还会收集您的
  <strong>
    <u>
      实名身份信息（身份信息、姓名、⼿机号、地址、⾯部⽣物识别信息
    </u>
  </strong>
  ⽤于校验您的卖家身份，同时我们将收集您所填写的⽤于收款的
  <strong>
    <u>
      银⾏卡信息或第三⽅⽀付信息
    </u>
  </strong>
  ⽤于您的货款结算。
</p>
<p>
  您也可在⾮登陆注册状态下使⽤图灵鉴定App/微信⼩程 序/图灵鉴定H5，我们会收集您的IMEI、IMSI、设备类型、系统版本、IP地址等设备信息。如果您不提供上述信息，可能⽆法使⽤图灵鉴定App/微信⼩程序/图灵鉴定H5
  的服务。
  <strong>
    <u>
      但请注意：单独的设备信息⽆法识别特定⾃然⼈的个⼈信息。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong>
    （⼆）交易
  </strong>
</p>
<p>
  1、当您在图灵鉴定App/微信⼩程序/图灵鉴定H5购买商品时：
</p>
<p>
  （1）我们需要收集您的
  <strong>
    <u>
      收货姓名、联系⽅式及收货地址
    </u>
  </strong>
  ，⽤于快递发货以及联系您收货；
</p>
<p>
  （2）我们需要收集您的
  <strong>
    <u>
      银⾏卡信息及第三⽅⽀付信息
    </u>
  </strong>
  ,⽤于您在购买商品时进⾏⽀付以及完成⻛控验证；
</p>
<p>
  （3）当您在绑定您的银⾏卡时，我们需要收集您的
  <strong>
    <u>
      姓名、身份证号码、银⾏卡卡号、银⾏预留⼿机号码
    </u>
  </strong>
  ，给到第三⽅⽀付机构进⾏银⾏卡鉴权，确保是您本⼈持卡消费。如您绑定信⽤卡，我们还将收集您的
  <strong>
    <u>
      卡⽚有效期、安全码
    </u>
  </strong>
  ⽤于信⽤卡鉴权，确保是您本⼈持卡消费。其中，
  <strong>
    <u>
      有效期、安全码
    </u>
  </strong>
  为第三⽅⽀付机构收集后给到发卡银⾏进⾏身份校验，图灵鉴定App/微信⼩程序/图灵鉴定H5不会进⾏存储。您的
  <strong>
    <u>
      姓名、身份证号码、银⾏卡卡号、银⾏预留⼿机号码
    </u>
  </strong>
  将被收集并存储⽤于识别交易
</p>
<p>
  ⻛险，保障您的资⾦安全。
</p>
<p>
  （4）当您产⽣退款或者赔偿业务时，我们需要收集您的银⾏卡信息及第三⽅⽀付信息以及真实姓名，⽤于退款及赔偿的转账；
</p>
<p>
  （5）我们需要收集您的
  <strong>
    <u>
      操作⽇志
    </u>
  </strong>
  ，根据您的使⽤记录、设备信息、位置信息、收藏信息、订单信息，向您推荐相关商品；
</p>
<p>
  （6）我们在您⾃愿的前提下收集您对商品的评价，给予他⼈参考。对于身⾼、体重、尺码，您可以选填，如您不提供前述信息，并不影响您使⽤我们的评价功能。
</p>
<p>
  （7）商品进⾏图⽚搜索时，会调⽤⽤户的
  <strong>
    <u>
      相册权限、摄像头权限
    </u>
  </strong>
  ，⽤于您拍摄商品照⽚上传后能快速寻找对应商品。
</p>
<p>
  （8）我们会在您扫描鉴别结果信息时，调⽤您的摄像头权限，⽤户可扫描⼆维码获知商品鉴别结果。
</p>
<p>
  2、当您在图灵鉴定App/微信⼩程序/图灵鉴定H5销售商品时：
</p>
<p>
  （1）我们需要收集您的
  <strong>
    <u>
      姓名、身份证号码、⾯部⽣物识别信息、电话、地址、身份信息
    </u>
  </strong>
  ， 用于按照相关法律确认卖家身份及完成⻛控验证；
</p>
<p>
  （2）我们需要收集您的
  <strong>
    <u>
      ⽀付信息
    </u>
  </strong>
  ，⽤于您接收买家⽀付的货款以及完成⻛控验证；
</p>
<p>
  （3）我们需要收集您的
  <strong>
    <u>
      收货姓名、联系⽅式以及收货地址
    </u>
  </strong>
  ，以便您接受买家或平台退货；
</p>
<p>
  （4）当您产生退款、赔偿、提现业务时，我们需要收集您的
  <strong>
    <u>
      ⽀付信息以及真实姓名
    </u>
  </strong>
  ，用于退款或赔偿转账；
</p>
<p>
  （5）我们需要申请您的
  <strong>
    <u>
      相册权限（如照⽚存储在外置SD卡中，则需要调取SD卡中照⽚信息）或摄像头权限
    </u>
  </strong>
  ，用于您在添加出售商品时，补充商品照⽚。
</p>
<p>
  （6）我们需要申请您的
  <strong>
    <u>
      摄像头权限
    </u>
  </strong>
  ，扫描您的发货运单号，便于您的商品发货。
</p>
<p>
  （7）您在购物过程中可能需要与客服沟通，我们可能会调⽤您的摄像头权限⽤于您上传照⽚或视频。同时为便于与您联系、帮助您解决问题，我们可能会保存您与我们的
  <strong>
    <u>
      相关聊天内容（包括账号信息、订单信息、您为了证明相关事实提供的其他信息或您留下的联系⽅
    </u>
  </strong>
</p>
<p>
  <strong>
    <u>
      式信息等）
    </u>
  </strong>
  ，如果您咨询事项与具体订单相关，我们还会使⽤到您的账号信息和订单信息。
</p>
<p>
  <br>
</p>
<p>
  <strong>
    （三）服务功能
  </strong>
</p>
<p>
  1、当您在使⽤上传商品、AI鉴别等功能时，我们会申请你的
  <strong>
    <u>
      相册权限、摄像头权限
    </u>
  </strong>
  ，征得您的同意开通权限后，获得您的图⽚内容以实现商品信息录⼊、鉴别真伪。如您不同意开通上述⼿机权限，可能⽆法正常使⽤包墙功能，但是不影响您使⽤我们提供的其他服务。
</p>
<p>
  2、在您使⽤鉴别功能时，我们需要申请开通您的 ⼿机相册权限（如照⽚存储在外置SD卡中，则需要调取SD卡中照⽚信息）、摄像头权限 ，⽤于拍摄并上传需要鉴别的商品的图⽚；我们需要收集您的
  <strong>
    <u>
      ⽀付信息
    </u>
  </strong>
  ,⽤于您在购买鉴别服务时进⾏⽀付以及完成⻛控验证。
</p>
<p>
  3、
  <strong>
    <u>
      您在使⽤服务功能的鉴别服务时发布的公开信息可能涉及您或他⼈的个⼈信息或个⼈隐私信息，如您在分享、评论时选择上传的包括个⼈信息的图⽚或视频。您应更为谨慎考虑是否公开该等信息，同时如该等信息中保护未成年⼈个⼈信息的，您在发布前征得其监护⼈同意。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong>
    （四）⻛控、安全管理
  </strong>
</p>
<p>
  在您使⽤我们服务过程中，为识别账号异常状态、了解产品适配性、向您提供更契合您需求的⻚⾯展示和搜索结果，我们可能会⾃动收集您的使⽤情况并存储为⽹络⽇志信息，包括：
</p>
<p>
  1、设备信息：我们会根据您在软件安装及/或使⽤中的 具体操作，接收并记录您所使⽤的设备硬件信息（包括设备型号、操作系统版本、设备设置、唯⼀设备标识符、设备环境等软硬件特征信息等）、系统参数、设备所在位置相关信息（包括您授权的GPS位置以及WLAN
  接⼊点、蓝⽛和基站等传感器信息）、系统软件列表设备唯⼀标识码等设备信息。
</p>
<p>
  2、服务⽇志信息：当您使⽤图灵鉴定App/微信⼩程序/图灵鉴定H5提供的产品或服务时，我们会⾃动收集您对我们服务的详细使⽤情况，作为服务⽇志保存，包括浏览、点击查看、搜索查询、收藏、交易、售后、关注分享信息、发布信息，以及IP地址、访问⽇期和时间等⾏为信息。
</p>
<p>
  <strong>
    <u>
      您应了解：单独的设备信息、服务⽇志信息是⽆法识别特定⾃然⼈身份的信息。
    </u>
  </strong>
  如果我们将这类⾮个⼈信息与其他信息结合⽤于识别特定⾃然⼈身份，或者将其与个⼈信息结合使⽤，则在结合使⽤期间，这类⾮个⼈信息将被视为个⼈信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。
</p>
<p>
  另外，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使⽤您的相关个⼈信息⽆需征求您的授权同意：
</p>
<p>
  （1)与国家安全、国防安全等国家利益直接相关的；
</p>
<p>
  （2)与公共安全、公共卫⽣、公共知情等重⼤公共利益直接相关的；
</p>
<p>
  （3)与犯罪侦查、起诉、审判和判决执⾏等直接相关的；
</p>
<p>
  （4)出于维护您或其他个⼈的⽣命、财产、声誉等重⼤合法权益但⼜很难得到本⼈同意的；
</p>
<p>
  （5)所收集的个⼈信息是您⾃⾏向社会公众公开的；
</p>
<p>
  （6)从合法公开披露的信息中收集个⼈信息的，如合法的新闻报道、政府信息公开等渠道；
</p>
<p>
  （7)根据您要求签订和履⾏合同所必需的；
</p>
<p>
  （8)⽤于维护所提供的产品或服务的安全稳定运⾏所必需的，例如发现、处置产品或服务的故障；
</p>
<p>
  （9)法律法规规定的其他情形。
</p>
<p>
  <br>
</p>
<p>
  <br>
</p>
<p>
  <strong>
    <u>
      如果您选择使⽤前述说明当中尚未涵盖的其他服务，基于该服务我们需要收集您的信息的，我们会征得您的同意。我们会按照本政策以及相应的⽤户协议约定使⽤、存储、对外提供及保护您的信息；如您选择不提供前述信息，您可能⽆法使⽤某项或者某部分服务，但是不影响您使⽤我们提供的其他服务。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong>
    三、我们如何使用Cookie和第三方服务
  </strong>
</p>
<p>
  （一）当您使用图灵鉴定服务的时候，我们会保护您的登录状态并且为您分配一个或多个“Cookie”（一种很小的文本文件），例如：若您访问一种需要您登录才可以提供的产品及/或服务，当您登录时，我们会把您的登录名加密存储在您的Cookie文件中，由于是不可逆转的加密存储，其他人即使可以使用您的设备，也无法识别出您的登录名。您并不需要额外做任何工作，所有的收集、保存和加密工作都由系统自动完成。
</p>
<p>
  （二）为了向您提供更为方便、快捷、顺畅、个性化的服务，我们通过Cookie等技术为您提供以下服务：记住您的登录信息及登录状态，帮助您省去为使用我方服务而重复输入账户信息的步骤，帮助判断您的账户安全状态
</p>
<p>
  <strong>
    （三）第三方服务
  </strong>
</p>
<p>
  <strong>
    1、第三方H5页面
  </strong>
</p>
<p>
  为了提供第三方服务，我们可能会接入第三方的H5服务页面，包括第三方支付服务页面、第三方应用页面，如果您进入这些H5页面，该第三方可能会收集您的手机号、个人生物识别信息、银行卡号、应用账号，请注意，您在以上第三方H5页面进行的各项操作将遵循该第三方服务商的隐私保护政策。当您离开我们平台跳转至第三方H5页面时，我们提醒您注意保护个人隐私。本平台不收集、不存储您在其他第三方服务页面填写和提交的任何个人信息。
</p>
<p>
  <strong>
    2、第三方SDK
  </strong>
</p>
<p>
  本平台的产品中将包含多个外部第三方SDK或其他类似的应用程序，如您在我们平台上使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息（如以嵌入代码、业务功能及目的）。
</p>
<p>
  <strong>
    请您知悉，我们不会向任何提供技术服务和技术支持的外部第三方SDK共享包括姓名、身份证、手机号码、银行卡在内的任何您的个人敏感信息。
  </strong>
  为了最大程度保障您的信息安全，我们建议您在使用任何第三方SDK类服务前先行查看其隐私条款。为保障您的合法权益，如您发现这等SDK或其他类似的应用程序存在风险时，建议您立即终止相关操作并及时与我们取得联系。
</p>
<p>
  <br>
</p>
<p>
  <strong>
    四、我们如何管理及保护您的个⼈信息
  </strong>
</p>
<p>
  （⼀）我们如何保护您的个⼈信息
</p>
<p>
  1、对于收集的信息，我们努⼒采取符合业界标准、合理可⾏的安全防护措施保护您的信息，以防⽌信息的泄露、丢失、不当使⽤、未经授权访问、修改和披露等。我们采取多⽅位的安全保护措施，以确保⽤户的个⼈信息保护处于合理的安全⽔平，包括管理制度控制、安全体系保障等诸多⽅⾯。我们会部署访问控制机制，尽⼒确保只有被授权的⼈员才可访问个⼈信息；以及我们会举办安全和隐私保护培训课程，加强员⼯对于保护个⼈信息重要性的认识。对于违反义务的⼈员会根据相关规定进⾏处罚。
</p>
<p>
  我们保证我们收集的信息，都是必要的。我们会尽⼒避免收集⽆关的个⼈信息。
  <strong>
    <u>
      我们只会在达成本政策所述⽬的所需的期限内保留您的个⼈信息，除⾮法律有强制的存留要求
    </u>
  </strong>
  ， 例如《中华⼈⺠共和国电⼦商务法》要求商品和服务信息、交易信息保存时间⾃交易完成之⽇起不少于三年。
  <strong>
    <u>
      在您的个⼈信息超出保留期间后，我们会根据适⽤法律的要求删除您的个⼈信息，或使其匿名化处理。
    </u>
  </strong>
</p>
<p>
  <strong>
    <u>
      我们将在中华⼈⺠共和国境内运营所收集或产⽣的个⼈信息存储在中华⼈⺠共和国境内。
    </u>
  </strong>
</p>
<p>
  2、我们建议您在使⽤产品和服务时充分注意对个⼈信息的 保护，我们也会提供多种安全功能来协助您保护⾃⼰的个⼈信息安全。您应当重视您的个⼈信息的保护，
  <strong>
    <u>
      您如果发现您的个⼈信息已经被泄露或者存在被泄露的可能，且有可能会危及您注册获得的图灵鉴定App/微信⼩程序/图灵鉴定H5账户安全，或者给您造成其他的损失的，您务必在第⼀时间通知平台，以便平台采取相应的措施确保您的图灵鉴定App/微信⼩程序/图灵鉴定H5账户安全，防⽌损失的发⽣或者进⼀步扩⼤；否则，平台⽆须承担由此给您造成的任何损失（及扩⼤的损失）
      。
    </u>
  </strong>
</p>
<p>
  3、您充分理解并完全接受：即便是图灵鉴定App/微信⼩程序/图灵鉴定H5采取各种安全技术和程序存储、保护⽤户 信息，防⽌其被未经授权的访问、使⽤、复制和泄露，但⽤户信息仍然有可能发⽣被⿊客攻击、窃取，因不可抗⼒或者其他⾮图灵鉴定App/微信⼩程序/图灵鉴定H5的⾃身原因⽽被泄露的情形。对此，只要是平台采取了必要的措施防⽌上述情形之发⽣，并在上述情形发⽣之后采取必要的措施防⽌其损失进⼀步扩⼤，平台则⽆须赔偿由此给您造成的任何损失。
</p>
<p>
  当我们的服务发⽣停⽌运营的情形时，我们会将停⽌运营的情况以公告的形式向您发送推送。并及时将收集的您的个⼈信息进⾏删除。
</p>
<p>
  <br>
</p>
<p>
  （⼆）我们如何管理您的个⼈信息
</p>
<p>
  1、我们只会在达成本政策所述目的所需的最短期限内保存您的个人信息，除非法律有强制的存留要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。
</p>
<p>
  2、我们将在中华人民共和国境内运营所收集或产生的个人信息，个人信息被存储在中华人民共和国境内。
</p>
<p>
  3、在您终止使用某项服务后，我们会停止对您的信息的收集和使用，法律法规或监管部门另有规定的除外。如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。
</p>
<p>
  4、当您成功申请注销账户后，我们仅在法律规定范围内最短期限保存您的个人信息，但不再对您的个人信息进行商业化使用；当您的个人信息超出上述保存期限，我们将对您的个人信息进行删除或匿名化处理。
</p>
<p>
  <strong>
    五、 您的权利
  </strong>
</p>
<p>
  在您使用图灵鉴定期间，为了您可以更加便捷地查阅、复制、更正、删除您的个人信息，同时保障您撤回对个人信息处理的同意及注销账号的权利，我们在产品设计中为您提供了相应的操作设置，您可以参考下面的指引进行操作。您的意见及请求将会得到及时的处理。
</p>
<p>
  请注意，不同操作系统、图灵鉴定软件的不同版本之间，操作设置可能存在差异；此外，为了优化您的使用体验，我们也可能对操作设置进行调整。故如下指引仅供参考，若您对行使相关权利的方式和途径仍有任何疑问，您可以按照文末披露的方式与我们联系。
</p>
<p>
  1、查询、更正、补充您的个⼈信息
</p>
<p>
  （1）账户信息：如果您希望查询并管理您账户中的个⼈基本资料信息，您可以通过"我的"，然后点击相应位置来更改头像、昵称、性别、密码等。
</p>
<p>
  （2）订单信息：您可以在订单⻚⾯查看您作为卖家或买家的出售的商品的订单。
</p>
<p>
  （3）消息通知：我们会通过平台内的消息通知功能与您取得联系。
</p>
<p>
  （4）收款账户：如果您希望管理您的收款账户，可以到我的⻚⾯点击账户查看
</p>
<p>
  2、改变您授权同意的范围
</p>
<p>
  图灵鉴定平台每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以改变或者收回您授权我们收集和处理您的个人信息的范围：您可以通过您的⼿机系统设置来管理、开通或关闭系统权限，包括但不限于相册、摄像头、⻨克⻛、地理位置等系统权限。
  <strong>
    <u>
      但请注意，对于部分类型的个人信息，例如实现图灵鉴定平台基本功能所必须的信息或我们履行法律法规规定的义务所必需的信息，我们可能没有办法相应您改变授权范围的请求。
    </u>
  </strong>
</p>
<p>
  3、逝者近亲属的权利
</p>
<p>
  如图灵鉴定用户不幸逝世，其近亲属可通过文末披露的方式与我们联系，以获取相关指引行驶法律规定的合法、正当权益。
</p>
<p>
  4、约束自动化决策
</p>
<p>
  在某些业务功能中，我们可能仅依据算法在内的非人工自动化决策机制做出决定。如果这些决定影响您的合法权益，您可以通过本政策文末披露的方式与我们联系。
</p>
<p>
  5、响应您的上述请求
</p>
<p>
  <strong>
    <u>
      为保障您的账户安全，您向我们提出上述请求时，我们可能会先要求您验证您的身份（如要求您提供书面请求或其他方式），然后再处理您的请求。
    </u>
  </strong>
  对于您向我们提出的上述请求，我们将在15个工作日内作出答复
</p>
<p>
  对于您的合理请求，我们原则上不收取费用。
  <strong>
    <u>
      但对于多次重复、超出合理限度的请求，我们将视情况收取一定的成本费用。对于无端重复、需要过多技术手段（例如：需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
    </u>
  </strong>
</p>
<p>
  <strong>
    在以下情形中，我们将无法响应您的请求：
  </strong>
</p>
<p>
  <strong>
    <u>
      （1）与我们履行法律法规的义务相关的；
    </u>
  </strong>
</p>
<p>
  <strong>
    <u>
      （2）与国家安全、国防安全直接相关的；
    </u>
  </strong>
</p>
<p>
  <strong>
    <u>
      （3）与公共安全、公共卫生、重大公共利益直接相关的；
    </u>
  </strong>
</p>
<p>
  <strong>
    <u>
      （4）与刑事侦查、起诉、审批或执行判决等直接相关的；
    </u>
  </strong>
</p>
<p>
  <strong>
    <u>
      （5）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；
    </u>
  </strong>
</p>
<p>
  <strong>
    <u>
      （6）出于维护个人信息主体或者其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
    </u>
  </strong>
</p>
<p>
  <strong>
    <u>
      （7）响应个人信息主体的请求将导致个人信息主体或其他个人、组织合法权益受到严重损害的；
    </u>
  </strong>
</p>
<p>
  <strong>
    <u>
      （8）涉及商业秘密的。
    </u>
  </strong>
</p>
<p>
  <strong>
    六、 我们如何共享、转让、公开披露您的信息
  </strong>
</p>
<p>
  <strong>
    （⼀）共享
  </strong>
</p>
<p>
  我们不会向图灵鉴定App/微信⼩程序/图灵鉴定H5服务提供商之外的其他第三⽅共享您的信息，但您应知悉以下情况下除外：
</p>
<p>
  <strong>
    （1）在法定情形下的共享：
  </strong>
  我们可能会根据法律法规规定、诉讼、争议解决需要，或按⾏政、司法机关依法提出的要求，对外共享您的个⼈信息。
</p>
<p>
  <strong>
    （2）在获取明确同意的情况下共享：
  </strong>
  在获得您明确授权同意的情况下，将您的信息共享给第三⽅。例如您在使⽤保养业务时，您的必要信息（账户信息）将在您的授权下提供给相应的保养服务提供商；
</p>
<p>
  <strong>
    （3）在您主动选择情况下共享：
  </strong>
  您通过图灵鉴定App/微信⼩程序/图灵鉴定H5购物或使⽤图灵鉴定App/微信⼩程/图灵鉴定H5服务时，我们会将您的购物订单或服务中所涉及交易或服务的必要信息共享给您的交易或服务相对⽅，便于对⽅为您提供商品或服务。包括但不限于：快递物流服务提供商
  <strong>
    <u>
      （ 为派送服务所必须的订单信息、收货⼈姓名、联系⽅式、地址信息等 ）
    </u>
  </strong>
  、商品鉴别服务提供商
  <strong>
    <u>
      （ 为鉴别服务所必须的订单信息、商品信息 ）
    </u>
  </strong>
  、⾦融服务提供商
  <strong>
    <u>
      （ 为申请授信、使⽤授信所必须的姓名、身份证号码、银⾏卡号码及预留⼿机号码、订单信息等，为⾦融⻛控所必须的设备信息等 ）
    </u>
  </strong>
  、 第三⽅⽀付机构
  <strong>
    <u>
      （ 为银⾏卡快捷⽀付所必须的姓名、身份证号码、银⾏卡卡号、预留⼿机号码、有效期、安全码，其中有效期、安全码仅收集并提供给第三⽅⽀付机构进⾏银⾏卡鉴权，不进⾏任何形式的存储
      ） 。
    </u>
  </strong>
</p>
<p>
  <strong>
    （4）与第三方服务提供商共享：
  </strong>
  为便于图灵鉴定App/微信⼩程序/图灵鉴定H5向您提供更优质的服务、识别⽤户账号的安全性、保护图灵鉴定App/微信⼩程序/图灵鉴定H5或其他第三⽅的利益不受侵害，您的个⼈信息可能会与我们的服务提供商共享。但我们将会对信息进⾏去标识化处理或要求我们的服务商提供更为严格的数据保护措施。包括：我们将会将您拍摄的鞋款图⽚信息共享给阿⾥云，通过图⽚分析获得您图⽚所对应的商品信息并给您反馈，过程中仅涉及商品照⽚数据传输；我们将在使⽤第三⽅提供的算法推荐服务的情况下向第三⽅共享⾏为⽇志信息，所涉信息均做脱敏处理等；我们在进⾏内容安全审核时会向第三内容安全服务提供商同步您所发布的内容信息及必要的个⼈信息
  <strong>
    <u>
      （ 头像、昵称等 ）
    </u>
  </strong>
  以判断内容是否合法合规，但我们会要求第三⽅设⽴严格的数据保护措施；我们在对您的操作进⾏账户、交易等⻛险识别时，可能会将您的设备信息及个⼈信息
  <strong>
    <u>
      （ ⼿机号码 ）
    </u>
  </strong>
  同步给第三⽅安全服务提供商以判断你的操作⻛险，但我们会要求第三⽅设⽴严格的数据保护措施。
</p>
<p>
  <strong>
    （⼆）转让
  </strong>
</p>
<p>
  除⾮图灵鉴定App/微信⼩程序/图灵鉴定H5运营主体发⽣变 更，否则图灵鉴定App/微信⼩程序/图灵鉴定H5不会向任何第三⽅转让您的个⼈信息。如图灵鉴定App/微信⼩程序/
  图灵鉴定H5运营主体变更导致转让您的个⼈信息，我们也会严格要求受让主体按照本隐私权政策严格保护您的个
</p>
<p>
  ⼈信息。否则，我们将要求该受让主体重新向您征求授
</p>
<p>
  权同意。
</p>
<p>
  <br>
</p>
<p>
  <strong>
    （三）公开披露
  </strong>
</p>
<p>
  我们不会主动地将您的信息进行公开披露，我们仅会在以下情况下公开您的个人信息：
</p>
<p>
  1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；
</p>
<p>
  2、如果我们确定您出现违反法律法规或严重违反图灵鉴定平台相关协议及规则的情况，或为保护图灵鉴定平台用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及图灵鉴定平台已对您采取的措施。
</p>
<p>
  <strong>
    （四）共享、转让、公开披露个人信息时事先征得授权同意的例外
  </strong>
</p>
<p>
  根据法律法规规定，以下情形中，共享、转让、公开披露您的个⼈信息⽆需事先征得您的授权同意：
</p>
<p>
  （1）与国家安全、国防安全直接相关的；
</p>
<p>
  （2）与公共安全、公共卫⽣、重⼤公共利益直接相关的；
</p>
<p>
  （3）与犯罪侦查、起诉、审判和判决执⾏等直接相关的；
</p>
<p>
  （4）出于维护个⼈信息主体或其他个⼈的⽣命、财产等重⼤合法权益但⼜很难得到本⼈同意的；
</p>
<p>
  （5）个⼈信息主体⾃⾏向社会公众公开个⼈信息的；
</p>
<p>
  （6）从合法公开披露的信息中收集个⼈信息的，如合法的新闻报道、政府信息公开等渠道。
</p>
<p>
  请知悉，根据相关法律规定，
  <strong>
    <u>
      若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方法无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong>
    七、我们如何处理未成年⼈个⼈信息
  </strong>
</p>
<p>
  我们⾮常重视未成年⼈的个⼈信息保护。在电商活动中，我们推定您具有相应的⺠事⾏为能⼒。如您为未成年⼈，
  <strong>
    <u>
      请您确保您的⽗⺟或监护⼈已仔细阅读本隐私权政策，并就您使⽤图灵鉴定App/微信⼩程序/图灵鉴定H5获得您的⽗⺟或监护⼈的同意。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong>
    <u>
      我们不收集任何14周岁以下的未成年人个人信息，如果我们识别出您是未成年⼈，我们将通过联系您的监护人确认您使用图灵鉴定App/微信⼩程序/图灵鉴定H5是否获得监护⼈的同意。如发现在未事先获得可证实的父母或其他监护⼈同意的情况下收集到未成年⼈个⼈信息，我们会⽴刻删除相关信息。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  如果您的监护⼈不同意您按照本政策使⽤我们的服务或者向我们提供信息，请您⽴即停⽌向我们提供信息并及时通知我们，以便于我们将您已经提供的信息进⾏删除。
</p>
<p>
</p>
<p>
  如果您作为监护⼈，请您关注您监护的未成年⼈是否在未取得您的同意的前提下使⽤图灵鉴定App/微信⼩程序/ 图灵鉴定H5服务。
</p>
<p>
  <br>
</p>
<p>
  <strong>
    八、如何联系我们
  </strong>
</p>
<p>
  （1）登录图灵鉴定客户端，选择“我”，点击“客服中心”，通过在线客服取得我们联系。
</p>
<p>
  （2）您可以联系我们的专职邮箱联系我们，联系邮箱： service@turingsenseai.com。
</p>
<p>
  （3）联系地址：北京市海淀区财智国际大厦C座2010。
</p>
<p>
  <br>
</p>
<p>
  更新时间：2022年7⽉08⽇
</p>
`
export default {
  content,
  title: '图灵鉴定隐私权限'
}
